import React, { useCallback } from 'react';

import { Form } from 'react-bootstrap-5';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { profilePremiumSignupUrl } from 'bundles/connect/helpers/prospect_api';
import { faLock } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  bordered?: boolean;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  title?: React.ReactNode;
}

export default function Filter({ bordered, children, className, disabled = false, title }: Props) {
  const renderLabelWrapper = useCallback((children: React.JSX.Element) => {
    if (!disabled) return children;

    return (
      <a
        className="text-body" href={profilePremiumSignupUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        {children}
      </a>
    );
  }, [disabled]);

  return (
    <div title={disabled ? 'Premium Filter' : ''}>
      {title && (
        <div className="mb-1">
          <Form.Label className="m-0">
            {renderLabelWrapper(
              <div>
                {disabled ? <FontAwesomeIcon className="me-2 text-secondary" icon={faLock} /> : null}{title}
              </div>
            )}
          </Form.Label>
        </div>
      )}
      <div className={classNames({ 'p-2 border rounded': bordered }, className)}>
        {children}
      </div>
    </div>
  );
}
